import {type NumberProp, type SvgProps} from 'react-native-svg';
import {getDescriber} from '../../../screens/descriptor/DescriptorType';

export const RewardsIcon = ({
  size,
  ...props
}: SvgProps & {size?: NumberProp}) => {
  return getDescriber()?.getRewardsIcon(size, props);
};
